import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteUsers as apiDeleteUsers } from "../../api/apiUsers";
import { toast } from "react-hot-toast";
import getErrorMessageFromAxiosError from "../../utils/parseError";


export function useDeleteUsers() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteUsers,
        isPending: isDelete,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiDeleteUsers(req),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({
                queryKey: ["users"],
            });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something Wont Wrong!");
            toast.error(msg);
        },

    });

    return { deleteUsers, isDelete, error, results };
}
